export const SERVICE_HOURS_RANGE_PLACEHOLDER = '7:00 - 8:00';
